angular.module('storefrontApp')
    .controller('productListController', [
        '$scope',
        '$window',
        '$timeout',
        'pricingService',
        'catalogService',
        'productListService',
        'focusService',
        function (
            $scope,
            $window,
            $timeout,
            pricingService,
            catalogService,
            productListService,
            focusService,
        ) {
            $scope.productListPricesLoaded = false;
            $scope.productListPrices = [];

            $scope.currentPage = 1;
            $scope.isLastPage = false;
            $scope.dynamicProducts = [];

            $scope.filters = {
                currentColor: '',
            };

            $scope.loadMore = function () {
                $scope.loading = true;
                $scope.currentPage += 1;

                const searchCriteria = $window.productSearchCriteria;

                searchCriteria.pageNumber = $scope.currentPage;

                return catalogService.search(searchCriteria)
                    .then(function (response) {
                        const newProducts = response.data.products;
                        const productIds = newProducts.map((item) => item.id);

                        $scope.dynamicProducts = $scope.dynamicProducts.concat(newProducts);

                        if (productIds.length) {
                            productListService.getProductListData(productIds)
                                .then(function (result) {
                                    angular.extend($scope.colors, result.colors);
                                    angular.extend($scope.variations, result.variations);
                                });
                        }

                        $scope.isLastPage = response.data.metaData.isLastPage;
                        $scope.loading = false;
                    });
            };

            $scope.sizes = [];
            $scope.sizesLoaded = $scope.sizes.length > 5;

            const productIds = $window.productList.map((item) => item.id);

            if (productIds.length) {
                productListService.getProductListData(productIds)
                    .then(function (result) {
                        angular.extend($scope, result);
                    });
            }

            if ($window.productList.length) {
                pricingService.getActualProductPrices($window.productList)
                    .then(function (response) {
                        const prices = response.data;

                        if (prices.length) {
                            for (let i = 0; i < prices.length; i += 1) {
                                $scope.productListPrices[prices[i].productId] = prices[i];
                            }
                        }

                        const productListPricesSize = $scope.getObjectSize($scope.productListPrices);

                        $scope.productListPricesLoaded = productListPricesSize > 0;
                    });
            }

            /* * /
            $scope.getImageForColor = function (color) {
                // , "display": angular.isDefined($scope.colors[color]) ? "inline-block" : "none"
                return {
                    'background-image': 'url(' + $scope.colors[color] + ')',
                };
            };
            /* */

            $scope.updateFilters = function (event) {
                // WCAG 2.4.3: applying a facet is a full page reload, which resets
                // focus to the top of the document — leaving keyboard/SR users above
                // the menu and breadcrumb instead of on the results they just changed.
                // Flag the intent so the reloaded page can move focus to the results.
                $window.sessionStorage.setItem('rsFocusResults', '1');
                $window.location.href = $(event.currentTarget).find('a')[0].href;
            };

            $scope.addSize = function (size) {
                const newElement = $scope.getTextForSize(size);

                if (_.findIndex($scope.sizes, (e) => e === newElement) < 0) {
                    $scope.sizes.push(newElement);
                }
            };

            $window.addEventListener('beforeunload', function () {
                if ($scope.currentPage > 1) {
                    const key = $window.location.href;
                    const now = new Date();

                    $window.sessionStorage.setItem(key, JSON.stringify({
                        page: $scope.currentPage,
                        expired: now.setMinutes(now.getMinutes() + 10),
                        scrollPosition: $window.scrollY,
                    }));
                }
            });

            let resizeTimeout = null;

            function checkWindowSize() {
                $scope.collapsedFilters = $window.innerWidth < 768;
            }

            checkWindowSize();

            angular.element($window)
                .bind('resize', function () {
                    $timeout.cancel(resizeTimeout);
                    resizeTimeout = $timeout(checkWindowSize, 10);
                });

            // WCAG 2.4.3: if this load was triggered by applying a facet, move focus
            // to the results region so the keyboard/SR user lands on the changed list
            // (the #search-results target is rendered by collection-dynamic.liquid).
            if ($window.sessionStorage.getItem('rsFocusResults')) {
                $window.sessionStorage.removeItem('rsFocusResults');
                focusService.focusRegion('search-results');
            }

            // load position
            const key = $window.location.href;
            const stored = $window.sessionStorage.getItem(key);

            if (stored) {
                $window.sessionStorage.removeItem(key);

                const obj = JSON.parse(stored);

                if (Date.now() < obj.expired) {
                    (function load() {
                        $scope.loadMore()
                            .then(function () {
                                if ($scope.currentPage < obj.page) {
                                    load();
                                } else {
                                    $timeout(function () {
                                        $window.scroll(0, obj.scrollPosition);
                                    }, 10);
                                }
                            });
                    }());
                }
            }
        },
    ]);
